var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React, { Component } from 'react';
import BrandModal from 'molecules/BrandModal';
import WatchlistShare from 'organisms/WatchlistShare';
var WatchlistShareModal = /** @class */ (function (_super) {
    __extends(WatchlistShareModal, _super);
    function WatchlistShareModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WatchlistShareModal.prototype.render = function () {
        var _a = this.props, deleteSession = _a.deleteSession, open = _a.open, sessionId = _a.sessionId, shareSession = _a.shareSession, toggleAction = _a.toggleAction;
        return (_jsx(BrandModal, __assign({ label: 'Merkliste mitnehmen', open: open, toggleAction: toggleAction }, this.props, { children: _jsx(WatchlistShare, { deleteSession: deleteSession, sessionId: sessionId, shareSession: shareSession }, void 0) }), void 0));
    };
    return WatchlistShareModal;
}(Component));
export default WatchlistShareModal;
